import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { captureAttributionFromUrl } from '@/analytics/attribution';
import { applyUrlActions } from '@/app/urlActions';
import { initWebVitals, installGlobalErrorTracking } from '@/analytics/health';
import { App } from './app/App';
import './styles/globals.css';

// Атрибуция с лендинга захватывается до первого рендера — пока параметры ещё в адресе (AUTH-7).
captureAttributionFromUrl();
// `?action=register|login|subscribe&plan=` читается до рендера и вычищается из адреса (AUTH-8, BILL-3).
applyUrlActions();
installGlobalErrorTracking();
initWebVitals();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
